// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"4eea181b","553":"b8880202","931":"3bb404b7"}[chunkId] + ".chunk.js";
};